/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import generateId from 'utils/embeds/id_generator';
import ContentType from 'material/embeds/contenttype/contenttype';
import Embed from 'material/embeds/embed/embed_container';
import Delete from 'material/embeds/embed/edit/delete/delete_container';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentcard/contentcard_styles';



/* ========== ~~~~~~~~~~ CONTENT CARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ContentCard = (props) => {
    const isSelected = () => {
        const selectedContent = props.selectedContent === 'none' ? '0' : props.selectedContent;
        return selectedContent === props.contentId && props.isClickable;
    };
    const _renderDeleteButton = () => {
        const contentData = props.contents[props.contentId];
        const isSaved = !!contentData.questionBased.contentUUID || !!contentData.story.contentUUID;
        if(!isSaved){
            return  <Delete contentId={props.contentId} optionId={null} position={`bottom right`} />
        }
    };
    return (
        <div id={`contentcard-${generateId()}`} className={`contentcard ${props.classes.contentcard} ${props.type} ${props.size} clickable-${props.isClickable} selected-${isSelected()}`}>
            {props.contentOrder !== 'ordered' ? null :
                <div className={`contentnumber`}>
                    {props.number}
                </div>
            }
            {_renderDeleteButton()}
            <div className={`contentvisual`} onClick={props.processClick}>
                <ContentType contentId={props.contentId} type={props.type} text={props.text} selectable={false} isLive={true} />
                <Embed contentId={props.contentId} isEditable={false} />
                <div className={`overlay`}><Icon name={`check-circle`} /></div>
            </div>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ContentCard);
